"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTextFieldPort = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsTextFieldMasked = require("./DmsTextFieldMasked");
const _excluded = ["name", "label", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Mask function for port numbers.
 *
 * Ensures that the input value is a valid port number between 0 and 65535.
 *
 * @param {string} value - The raw input value to be masked.
 * @returns {string} The masked value formatted as a valid port number.
 */
const PortMask = value => {
  // Remove all non-numeric characters
  value = value.replace(/\D/g, "");

  // Convert the value to a number and ensure it doesn't exceed the maximum port number
  let num = parseInt(value, 10);
  if (num > 65535) {
    num = 65535;
  }

  // Return the number as a string, or an empty string if it's not a valid number
  return isNaN(num) ? "" : num.toString();
};

/**
 * A text field component specifically for entering port numbers.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.name - The name attribute of the input field.
 * @param {string} props.label - The label text displayed for the input field.
 * @param {string} props.placeholder - The placeholder text shown in the input field.
 * @param {string} [props.value] - The current value of the input field.
 * @param {boolean} [props.disabled] - If true, the input field will be disabled.
 * @param {boolean} [props.fullWidth] - If true, the input field will take up the full width of its container.
 * @param {boolean} [props.required] - If true, the input field will be marked as required.
 * @returns {JSX.Element} The rendered TextField component configured for port number input.
 */
const DmsTextFieldPort = _ref => {
  let {
      name = "port",
      label = "Port",
      placeholder = "XXXXX"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DmsTextFieldMasked.DmsTextFieldMasked, _extends({
    name: name,
    label: label,
    placeholder: placeholder
  }, props, {
    maskFunction: PortMask
  }));
};
exports.DmsTextFieldPort = DmsTextFieldPort;
DmsTextFieldPort.propTypes = _objectSpread({}, _DmsTextFieldMasked.DmsTextFieldMasked.propTypes);